export const hasSameContents = (arr1, arr2) => {
  if (arr1.length !== arr2.length) return false;

  const counts = new Map();

  for (const value of arr1) {
    counts.set(value, (counts.get(value) || 0) + 1);
  }

  for (const value of arr2) {
    const remaining = counts.get(value);
    if (!remaining) return false;
    remaining === 1 ? counts.delete(value) : counts.set(value, remaining - 1);
  }

  return counts.size === 0;
};
